import { createBrowserRouter, RouterProvider } from "react-router-dom";
import {
  HomeLayout,
  Landing,
  Register,
  Login,
  DashboardLayout,
  Error,
  AddBuilding,
  Stats,
  AllBuildings,
  AllScreens,
  Profile,
  Admin,
  AddMessage,
  AllMessages,
  AddMedia,
  AllMedia,
  AdvertiserRequest,
  CampaignScheduler,
  AllAdvertisement,
  AddFloors,
  AddBusiness,
  AddFloorsNavigation,
  DeleteBuilding,
  ShowBuildingScreen,
  EditBuilding,
  VerifyEmail,
  AddMediaBuilding,
  ConnectPage,
  ChooseScreenPage,
  ShowMessages,
  AllCampaignSchedules,
  EditMessage,
  AllOfficeBuildings,
  ShowOfficeNavigationScreen,
  ForgotPassword,
} from "./pages";

import { loader as dashboardLoader } from "./pages/DashboardLayout";
import { loader as allBuildingLoader } from "./pages/AllBuildings";
import { loader as editBuildingLoader } from "./pages/EditBuilding";
import { loader as adminLoader } from "./pages/Admin";
import { loader as addMessageLoader } from "./pages/AddMessage";
import { loader as statsLoader } from "./pages/Stats";
import { loader as displayScreenLoader } from "./pages/ShowBuildingScreen";
import { loader as VerifyEmailLoader } from "./pages/VerifyEmail";
import { loader as AddMediaToBuildingLoader } from "./pages/AddMediaBuilding";
import { loader as connectScreenLoader } from "./pages/Connect";
import { loader as chooseScreenPageLoader } from "./pages/ChooseScreenPage";
import { loader as AllAdvertisementLoader } from "./pages/AllCampaigns";
import { loader as CampaignSchedulerLoader } from "./pages/CampaignScheduler";
import { loader as ShowMessagesLoader } from "./pages/ShowMessages";
import { loader as allSchedulesLoader } from "./pages/AllCampaignSchedules";
import { loader as editMessageLoader } from "./pages/EditMessage";
import { loader as allMessageLoader } from "./pages/AllMessages";
import { loader as loginLoader } from "./pages/Login";
import { loader as addFloorsLoader } from "./pages/AddFloors";
import { loader as allOfficeBuildingsLoader } from "./pages/AllOfficeBuildings";
import { loader as displayOfficeNavigationLoader } from "./pages/ShowOfficeNavigationScreen";

import { action as editMessageAction } from "./pages/EditMessage";
import { action as registerAction } from "./pages/Register";
import { action as loginAction } from "./pages/Login";
import { action as addBuildingAction } from "./pages/AddBuilding";
import { action as editBuildingAction } from "./pages/EditBuilding";
import { action as deleteBuildingAction } from "./pages/DeleteBuilding";
import { action as addMessageAction } from "./pages/AddMessage";
import { action as addMediaAction } from "./pages/AddMedia";
import { action as profileAction } from "./pages/Profile";
import { action as AddMediaToBuildingAction } from "./pages/AddMediaBuilding";
import { action as AdvertiserRequestAction } from "./pages/AdvertiserRequest";
import { action as CampaignSchedulerAction } from "./pages/CampaignScheduler";
import { action as addFloorsAction } from "./pages/AddFloorsNavigation";

// import { action as AllMessageAction } from './pages/AllMessages';
// import { action as VerifyEmailAction } from './pages/VerifyEmail';

const checkDefaultTheme = () => {
  const isDarkTheme = localStorage.getItem("darkTheme") === "true";
  document.body.classList.toggle("dark-theme", isDarkTheme);
  return isDarkTheme;
};

const isDarkThemeEnabled = checkDefaultTheme();

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: "/register",
        element: <Register />,
        action: registerAction,
      },
      {
        path: "/login",
        element: <Login />,
        action: loginAction,
        loader: loginLoader,
      },
      {
        path: "/connect",
        element: <ConnectPage />,
        loader: connectScreenLoader,
      },
      {
        path: "/verify-email/:_id",
        element: <VerifyEmail />,
        loader: VerifyEmailLoader,
        // action: VerifyEmailAction,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/public/:id",
        element: <ShowBuildingScreen />,
        loader: displayScreenLoader,
      },
      {
        path: "/office/:buildingId/:floorNumber?",
        element: <ShowOfficeNavigationScreen />,
        loader: displayOfficeNavigationLoader,
      },
      {
        path: "/dashboard",
        element: <DashboardLayout isDarkThemeEnabled={isDarkThemeEnabled} />,
        loader: dashboardLoader,
        children: [
          {
            index: true,
            element: <Stats />,
            loader: statsLoader,
          },
          {
            path: "stats",
            index: true,
            element: <Stats />,
            loader: statsLoader,
          },
          {
            path: "chooseScreen",
            index: true,
            element: <ChooseScreenPage />,
            loader: chooseScreenPageLoader,
          },
          {
            path: "add-building",
            element: <AddBuilding />,
            action: addBuildingAction,
          },
          {
            path: "all-buildings",
            element: <AllBuildings />,
            loader: allBuildingLoader,
          },
          {
            path: "all-office",
            element: <AllOfficeBuildings />,
            loader: allOfficeBuildingsLoader,
          },
          {
            path: "edit-building/:id",
            element: <EditBuilding />,
            loader: editBuildingLoader,
            action: editBuildingAction,
          },
          {
            path: "show-messages",
            element: <ShowMessages />,
            loader: ShowMessagesLoader,
          },
          {
            path: "add-message/:id/:messageId?",
            element: <AddMessage />,
            loader: addMessageLoader,
            action: addMessageAction,
          },
          {
            path: "delete-building/:id",
            action: deleteBuildingAction,
          },
          {
            path: "add-floor-navigation",
            element: <AddFloorsNavigation />,
            action: addFloorsAction,
          },
          // {
          //   path: "all-screens",
          //   element: <AllScreens />,
          // },
          {
            path: "add-floor/:floorNavigationId",
            element: <AddFloors />,
            loader: addFloorsLoader,
          },
          {
            path: "add-business",
            element: <AddBusiness />,
          },
          // {
          //   path: "add-business",
          //   element: <AddFloors />,
          // },
          {
            path: "all-messages",
            element: <AllMessages />,
            loader: allMessageLoader,
            // action: AllMessageAction,
          },
          {
            path: "messages/edit/:id",
            element: <EditMessage />,
            loader: editMessageLoader,
            action: editMessageAction,
          },
          {
            path: "add-media",
            element: <AddMedia />,
            loader: allBuildingLoader,
            action: addMediaAction,
          },
          {
            path: "add-media-building/:id",
            element: <AddMediaBuilding />,
            loader: AddMediaToBuildingLoader,
            action: AddMediaToBuildingAction,
          },
          {
            path: "all-media",
            element: <AllMedia />,
          },
          {
            path: "add-advertisement/:scheduleId?",
            element: <CampaignScheduler />,
            loader: CampaignSchedulerLoader,
            action: CampaignSchedulerAction,
          },
          {
            path: "advertiser-request",
            element: <AdvertiserRequest />,
            action: AdvertiserRequestAction,
          },
          {
            path: "advertiser-request/:campaignId",
            element: <AdvertiserRequest />,
            action: AdvertiserRequestAction,
          },
          {
            path: "all-advertisement",
            element: <AllAdvertisement />,
            loader: AllAdvertisementLoader,
          },
          {
            path: "all-schedules",
            element: <AllCampaignSchedules />,
            loader: allSchedulesLoader,
          },
          {
            path: "Profile",
            element: <Profile />,
            action: profileAction,
          },
          {
            path: "admin",
            element: <Admin />,
            loader: adminLoader,
          },
        ],
      },
    ],
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
